import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';

function Home() {
  const location = useLocation();
  const navigate = useNavigate();
  const nome = new URLSearchParams(location.search).get('nome');

  const handleLogout = async () => {
    // Envie a requisição para o logout.php
    const response = await fetch('https://react.rennan-alves.com/logout.php', {
      method: 'GET',
    });

    // Após o logout, redirecione para a página de login
    if (response.ok) {
      navigate('/login');
    }
  };

  return (
    <div className="container">
      <h1>Bem-vindo, {nome}!</h1>
      <button className="logout" onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default Home;